import customVideo from '../components/customVideo/index.vue'

const install = Vue => {
  Vue.component(customVideo.name, customVideo)
}

export default install